// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type DeleteRoom200Response,
    DeleteRoom200ResponseFromJSON,
    DeleteRoom200ResponseToJSON,
} from '../models/DeleteRoom200Response';
import {
    type RoomCreateInput,
    RoomCreateInputFromJSON,
    RoomCreateInputToJSON,
} from '../models/RoomCreateInput';
import {
    type RoomList,
    RoomListFromJSON,
    RoomListToJSON,
} from '../models/RoomList';
import {
    type RoomMetaInput,
    RoomMetaInputFromJSON,
    RoomMetaInputToJSON,
} from '../models/RoomMetaInput';
import {
    type RoomResponse,
    RoomResponseFromJSON,
    RoomResponseToJSON,
} from '../models/RoomResponse';

export interface CreateRoomRequest {
    /**
     * 
     */
    roomCreateInput: RoomCreateInput;
}

export interface DeleteRoomRequest {
    /**
     * Room ID
     */
    roomId: string;
}

export interface GetRoomRequest {
    /**
     * Room ID
     */
    roomId: string;
}

export interface UpdateRoomMetaRequest {
    /**
     * Room ID
     */
    roomId: string;
    /**
     * 
     */
    roomMetaInput: RoomMetaInput;
}

/**
 * 
 */
export class RoomsApi extends runtime.BaseAPI {

    /**
     * Creates request options for createRoom without sending the request
     */
    async createRoomRequestOpts(requestParameters: CreateRoomRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roomCreateInput'] == null) {
            throw new runtime.RequiredError(
                'roomCreateInput',
                'Required parameter "roomCreateInput" was null or undefined when calling createRoom().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/rooms/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoomCreateInputToJSON(requestParameters['roomCreateInput']),
        };
    }

    /**
     * Create a new room with the given ID and metadata
     * Create a new room
     */
    async createRoomRaw(requestParameters: CreateRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoomResponse>> {
        const requestOptions = await this.createRoomRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoomResponseFromJSON(jsonValue));
    }

    /**
     * Create a new room with the given ID and metadata
     * Create a new room
     */
    async createRoom(requestParameters: CreateRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoomResponse> {
        const response = await this.createRoomRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteRoom without sending the request
     */
    async deleteRoomRequestOpts(requestParameters: DeleteRoomRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roomId'] == null) {
            throw new runtime.RequiredError(
                'roomId',
                'Required parameter "roomId" was null or undefined when calling deleteRoom().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/rooms/{roomId}`;
        urlPath = urlPath.replace('{roomId}', encodeURIComponent(String(requestParameters['roomId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a room and its monitoring references
     * Delete a room
     */
    async deleteRoomRaw(requestParameters: DeleteRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteRoom200Response>> {
        const requestOptions = await this.deleteRoomRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteRoom200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete a room and its monitoring references
     * Delete a room
     */
    async deleteRoom(requestParameters: DeleteRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteRoom200Response> {
        const response = await this.deleteRoomRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getRoom without sending the request
     */
    async getRoomRequestOpts(requestParameters: GetRoomRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roomId'] == null) {
            throw new runtime.RequiredError(
                'roomId',
                'Required parameter "roomId" was null or undefined when calling getRoom().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/rooms/{roomId}`;
        urlPath = urlPath.replace('{roomId}', encodeURIComponent(String(requestParameters['roomId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve a specific room by its ID
     * Get room by ID
     */
    async getRoomRaw(requestParameters: GetRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoomResponse>> {
        const requestOptions = await this.getRoomRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoomResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve a specific room by its ID
     * Get room by ID
     */
    async getRoom(requestParameters: GetRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoomResponse> {
        const response = await this.getRoomRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getRooms without sending the request
     */
    async getRoomsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/rooms/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve a list of all rooms
     * Get all rooms
     */
    async getRoomsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoomList>> {
        const requestOptions = await this.getRoomsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoomListFromJSON(jsonValue));
    }

    /**
     * Retrieve a list of all rooms
     * Get all rooms
     */
    async getRooms(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoomList> {
        const response = await this.getRoomsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateRoomMeta without sending the request
     */
    async updateRoomMetaRequestOpts(requestParameters: UpdateRoomMetaRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roomId'] == null) {
            throw new runtime.RequiredError(
                'roomId',
                'Required parameter "roomId" was null or undefined when calling updateRoomMeta().'
            );
        }

        if (requestParameters['roomMetaInput'] == null) {
            throw new runtime.RequiredError(
                'roomMetaInput',
                'Required parameter "roomMetaInput" was null or undefined when calling updateRoomMeta().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/rooms/{roomId}/meta`;
        urlPath = urlPath.replace('{roomId}', encodeURIComponent(String(requestParameters['roomId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: RoomMetaInputToJSON(requestParameters['roomMetaInput']),
        };
    }

    /**
     * Update the metadata of a specific room, only submitted properties will be changed. To remove metadata, send a empty string.
     * Update room meta data
     */
    async updateRoomMetaRaw(requestParameters: UpdateRoomMetaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoomResponse>> {
        const requestOptions = await this.updateRoomMetaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoomResponseFromJSON(jsonValue));
    }

    /**
     * Update the metadata of a specific room, only submitted properties will be changed. To remove metadata, send a empty string.
     * Update room meta data
     */
    async updateRoomMeta(requestParameters: UpdateRoomMetaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoomResponse> {
        const response = await this.updateRoomMetaRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
